// frontend/src/components/ErrorPage.js
import React from 'react';
import { useSearchParams, Link } from 'react-router-dom'; // Import Link for navigation
import Layout from './Layout'; // Import the shared Layout component

/**
 * Component displayed when a significant server-side error occurs during authentication or other processes.
 * Provides a user-friendly message, optionally displays an error code from URL parameters,
 * and offers a link back to the login page. Renders within the shared application Layout.
 * @returns {React.ReactElement} The rendered Error Page component.
 */
function ErrorPage() {
  // Hook to read query parameters from the URL (e.g., /error?code=SERVER_ERROR)
  const [searchParams] = useSearchParams();
  // Get the value of the 'code' parameter, if present
  const errorCode = searchParams.get('code');

  return (
    // Use the shared Layout component. No 'user' prop is passed,
    // so the Layout will render the "Login" button in the header.
    <Layout>
      {/* Container for page-specific content */}
      {/* Uses flexbox to center content vertically and horizontally within the Layout's main area. */}
      {/* Removed min-h calculation to prevent overflow issues. */}
      <div className="relative z-20 flex flex-col items-center justify-center text-center px-4"> {/* Removed min-h-[calc(...)] */}

        {/* Error Message Box */}
        <div className="bg-red-900 bg-opacity-75 border border-red-700 p-8 rounded-lg shadow-lg max-w-lg">
            <h2 className="text-3xl font-semibold mb-4 text-red-300">Oops! Something Went Wrong</h2>
            <p className="text-red-100 mb-6">
                We encountered an unexpected issue while processing your request. Please try logging in again later.
                If the problem persists, please contact support.
            </p>
            {/* Optionally display the error code if provided in the URL */}
            {errorCode && (
                <p className="text-xs text-red-200 mb-6">
                    Error Code: {errorCode}
                </p>
            )}
            {/* Use React Router Link for client-side navigation back to login */}
            <Link
               to="/login"
               className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg shadow-md transition duration-300 ease-in-out"
            >
                Return to Login
            </Link>
        </div>

      </div>
    </Layout>
  );
};

export default ErrorPage;
